// File: config.navbar.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration used by cgp-nav-bar.
// Other Contributors:

import { baseConfig } from './config.base';

export const veNavItems = {
    id: 'VE',
    title: 'VE',
    iconClass: 'fa fa-fw fa-list-alt',
    expanded: true,
    url: '#/VE',
    data: {
        expectedRoles: ['Administrator', 'Manager', 'Lead', 'Engineer', 'User']
    },
    module: 'VE_Common',
    children: [
        {
            id: 'Administration',
            title: 'Administration',
            iconClass: 'fa fa-fw fa-cogs',
            expanded: false,
            url: '',
            data: {
                expectedRoles: ['Administrator']
            },
            module: 'VE_Common',
            children: [
                {
                    id: 'Areas',
                    title: 'Areas',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Areas',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Banner',
                    title: 'Banner Message',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Banner',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Common'
                },
                {
                    id: 'Default-Notification-Contacts',
                    title: 'Default Notifications Contacts',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Default-Notification-Contacts',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Common'
                },
                {
                    id: 'Gate',
                    title: 'Gates',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Gate',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Common'
                },
                {
                    id: 'mBOM',
                    title: 'mBOMs',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/mBOM',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Total-Vehicle-Number',
                    title: 'Total Vehicle Numbers',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Total-Vehicle-Number',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Tracking-Vehicle-Number',
                    title: 'Tracking Vehicle Numbers',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Tracking-Vehicle-Number',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Additional-Information-Category',
                    title: 'Additional Information Categories',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Additional-Information-Category',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'Architecture',
                    title: 'Architectures',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Architecture',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'CME-Area',
                    title: 'CME Areas',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/CME-Area',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'Ga-Program-Details',
                    title: 'Program Details',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Ga-Program-Details',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'SMT',
                    title: 'SMTs',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/SMT',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'Study-Titles',
                    title: 'Study Titles',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Study-Titles',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'Tooling-Operator-Interfaces',
                    title: 'Tooling Operator Interfaces',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Tooling-Operator-Interfaces',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_GA'
                },
                {
                    id: 'Deliverables',
                    title: 'Deliverables',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Deliverables',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Body-Program-Details',
                    title: 'Program Details',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Body-Program-Details',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Request-Type',
                    title: 'Request Types',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Request-Type',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Body'
                },
                {
                    id: 'Holiday-Schedule',
                    title: 'Holiday Schedules',
                    iconClass: '',
                    expanded: true,
                    url: '#/VE/Administration/Holiday-Schedule',
                    data: {
                        expectedRoles: ['Administrator']
                    },
                    module: 'VE_Common'
                },
            ]
        },
        {
            id: 'Work-Order-Schedule',
            title: 'Work Order Schedule',
            iconClass: 'fa fa-fw fa-briefcase',
            expanded: true,
            url: '#/VE/Work-Order-Schedule',
            data: {
                expectedRoles: ['Administrator', 'Lead']
            },
            module: 'VE_Common',
        },
        {
            id: 'Engineer-Schedule',
            title: 'Engineer Schedule',
            iconClass: 'fa fa-fw fa-calendar',
            expanded: true,
            url: '#/VE/Engineer-Schedule',
            data: {
                expectedRoles: ['Administrator', 'Lead', 'Engineer']
            },
            module: 'VE_Common',
        },
        {
            id: 'Work-Orders',
            title: 'Work Orders',
            iconClass: 'fa fa-fw fa-file-text',
            expanded: true,
            url: '#/VE/Work-Orders',
            data: {
                expectedRoles: ['Administrator', 'Manager', 'Lead', 'Engineer', 'User']
            },
            module: 'VE_Common',
        }
    ],
};

export const navItems = [veNavItems];

// Nav Bar Actions: Go in /src/app/shared/cgp-sidenav.service.ts
